import { createSelector } from 'reselect';
import _ from 'lodash';
import { generateRealmLocationOptionValue } from '../utils';

const autoCompleteSelector = (state: any) => state.autoComplete;

const autoCompleteTermSelector = createSelector(autoCompleteSelector, ({ term }) => term);

const autocompleteResultsSelector = createSelector(autoCompleteSelector, ({ results }) =>
  _.map(results, ({ data }: any) => {
    const value = generateRealmLocationOptionValue({
      region: data.region,
      realm: data.realm
    });
    return {
      label: value,
      value: value
    };
  })
);

const autoCompletesStatusSelector = createSelector(autoCompleteSelector, (acState) =>
  _.omit(acState, ['term', 'results'])
);

const generateTagsByTypeSelector = (entity: string, activity: string) => {
  return (state: any) =>
    state.siteMeta.recruitmentTags.filter(
      (tag: any) => tag[`supports_entity_${entity}`] && tag[`supports_activity_${activity}`]
    );
};

const generateGroupedTagsSelector = (entity: string, activity: string) =>
  createSelector(generateTagsByTypeSelector(entity, activity), (tags: any) => {
    const groupedTags = tags.reduce((accum: any, item: any) => {
      if (!accum[item.category]) {
        accum[item.category] = [];
      }
      accum[item.category].push(item);
      return accum;
    }, {});
    return Object.keys(groupedTags).map((category) => ({
      label: category,
      options: groupedTags[category].map((tag: any) => ({ label: tag.name, value: tag.id }))
    }));
  });

const generateAllTagsSelector = (entity: string, activity: string) =>
  createSelector(generateTagsByTypeSelector(entity, activity), (tags: any) => {
    return tags.map((tag: any) => ({
      label: tag.name,
      value: tag.id
    }));
  });

export {
  autoCompleteTermSelector,
  autocompleteResultsSelector,
  autoCompletesStatusSelector,
  generateAllTagsSelector,
  generateGroupedTagsSelector
};
